import React, { FC } from 'react';
import { ActionCardListT } from './types';
import { StyledActionCardList } from '@components/Organisms/ActionCardList/styled';
import { ActionCard } from '@components/Organisms/ActionCardList/ActionCard';
import { renderParagraphs } from '@lib/utils';

export const ActionCardList: FC<ActionCardListT> = ({
  heading,
  actionCards,
  display,
  subheading,
  cloudBackground,
}) => {
  if (!display) return null;

  return (
    <StyledActionCardList className="slice card-list" cloudBackground={cloudBackground}>
      <div className="slice__inner flex-col">
        <h2 className="slice__title card-list__title">{heading}</h2>
        {subheading && (
          <p className="text-center pb-8 w-2/3 mx-auto">
            {renderParagraphs({ body: subheading, hasMarkdown: true })}
          </p>
        )}
        <div className="card-list__cards">
          {actionCards.map((actionCard) => (
            <ActionCard key={actionCard.heading} {...actionCard} />
          ))}
        </div>
      </div>
    </StyledActionCardList>
  );
};
